/* ==========================================================================
   Cart count bubbles

   Keeps every [data-cart-count] node on the page in step with the cart, and
   pops it when the number goes up so an ajax add is visibly acknowledged.
   The markup and the initial number come from snippets/cart-count.liquid, so
   this only has to cover changes made without a page load.

   Every add path in the theme ends in a bubbling ajaxProduct:added — the
   theme's own AjaxProduct forms, and the Firefly bundle card's fetch — so one
   listener covers all of them. The event carries the added product rather than
   the cart, so the new total is read from the cart itself.

   Quantity edits on the cart page and in the drawer don't fire that event;
   they run through theme.CartForm.updateCount, which calls render() here.
   ========================================================================== */

(function () {
  'use strict';

  if (window.CartCount) {
    return;
  }

  var BUMP = 'cart-count--bump';

  function render(count) {
    count = parseInt(count, 10) || 0;
    var text = count > 99 ? '99+' : String(count);

    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      var changed = el.textContent.trim() !== text;

      el.textContent = text;
      el.hidden = count === 0;

      if (!changed || count === 0) return;

      /* Restart the animation rather than letting a second add be silent. */
      el.classList.remove(BUMP);
      void el.offsetWidth;
      el.classList.add(BUMP);
    });
  }

  function refresh() {
    var apply = function (cart) {
      if (cart && typeof cart.item_count !== 'undefined') render(cart.item_count);
    };

    if (window.theme && theme.cart && theme.cart.getCart) {
      theme.cart.getCart().then(apply).catch(function () {});
      return;
    }

    var url = (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(apply)
      .catch(function () {});
  }

  document.addEventListener('ajaxProduct:added', refresh);

  /* Restored from the back/forward cache: the seeded count may be stale. */
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) refresh();
  });

  /* Capture, because animationend from a bubble has no listener of its own. */
  document.addEventListener(
    'animationend',
    function (evt) {
      if (evt.target.hasAttribute && evt.target.hasAttribute('data-cart-count')) {
        evt.target.classList.remove(BUMP);
      }
    },
    true
  );

  window.CartCount = { render: render, refresh: refresh };
})();
